// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {getSingularEntityType} from 'nutshell-core/utils/get-singular-entity-type';

import {addNotification} from '../../notifications/index';

type Options = {
    jumpToUrl?: boolean;
    history: RouterHistory;
    onClose?: () => void;
};

export const handleEntitySave = (entity: any, options: Options) => {
    const name = entity.title || entity.name || entity.description;
    const url = entity.htmlUrl;

    // Set up default options
    const {jumpToUrl: jumpToUrl = false, onClose: onClose = () => {}} = options;

    const onClick = (e: React.SyntheticEvent<any>) => {
        // @ts-expect-error
        if (e.metaKey || e.ctrlKey) window.open(url);
        else if (entity.type === 'activities') {
            options.history.replace({
                ...options.history.location,
                hash: `/${entity.id}`,
                state: {modal: true},
            });
        } else if (entity.type === 'tasks') {
            options.history.replace({pathname: entity.htmlUrlPath, state: {modal: true}});
        } else {
            options.history.push(entity.htmlUrlPath);
        }
    };

    const title = entity.type ? `New ${getSingularEntityType(entity.type)} added` : 'Added';

    if (jumpToUrl) {
        // Close out the modal before navigating, so that a 'back' doesn't re-open
        // the modal (https://nutshell.atlassian.net/browse/NUT-12197)
        onClose();
        options.history.push(entity.htmlUrlPath);
    } else {
        pushNotification(title, name, onClick);
        onClose();
    }
};

// @ts-expect-error
const pushNotification = (title, body, onClick) => {
    addNotification(title, {
        body,
        icon: 'check',
        onClick,
    });
};
